/* eslint-disable */

/* `const contentTabs = document.querySelectorAll(".tab-container");` is selecting all the DOM elements
with the class name "tab-container" and storing them in a constant variable named `contentTabs`. */
const contentTabs = document.querySelectorAll(".tab-container");
const accordionTabs = document.querySelectorAll(".accordion-header__label");
/**
 * The function shows the active tab content by removing the "hidden" class from the corresponding
 * checkboxes, labels, and ingredients and adding it to the others.
 * @param tab - The parameter `tab` is a string that represents the currently selected tab. It is used
 * to filter and display the corresponding content related to that tab.
 *
 *
 */

const toggleProductHidden = (selector, selectedContent) => {
  selector.forEach((el) => {
    if (el.dataset.product == selectedContent) {
      el.classList.remove("hidden");
    } else {
      el.classList.add("hidden");
    }
  });
};

const showActiveTabContent = (tab) => {
  const productCheckboxes = document.querySelectorAll(".product-checkboxes");
  const productLabels = document.querySelectorAll(".label-container");
  const productIngredients = document.querySelectorAll(".tabbed-ingredients");
  const productTitles = document.querySelectorAll(".tab-title");

  toggleProductHidden(productCheckboxes, tab);
  toggleProductHidden(productLabels, tab);
  toggleProductHidden(productIngredients, tab);
  toggleProductHidden(productTitles, tab);
};

/**
 * This function toggles between selected and unselected states for content tabs.
 * @param SelectedTab - a DOM element representing the tab that was selected by the user.
 */
const toggleTabs = (selectedTab) => {
  contentTabs.forEach((tab) => {
    if (selectedTab.dataset.selected != "true") {
      selectedTab.dataset.selected = true;
    }
    if (tab.dataset.selected == "true" && tab != selectedTab) {
      tab.dataset.selected = false;
    }
  });
};

/**
 * This function adds a click event listener to each accordion tab and logs the corresponding tab
 * content.
 */
const showHideAccordions = () => {
  accordionTabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      const tabTargetElement = tab;
      const tabTarget = tab.dataset.target;
      toggleContent(tabTargetElement, tabTarget);
    });
  });
};

/**
 * The function toggles the visibility of a specific tab content while hiding all other tab contents.
 * @param tabTarget - The parameter `tabTarget` is a variable that represents the index of the tab that
 * was clicked on. It is used to identify which tab content should be toggled.
 */
const toggleContent = (tabTargetElement, tabTarget) => {
  const icon = tabTargetElement.querySelector(".accordion-header-icon");
  const tabContent = document.querySelectorAll(".accordion-body");
  tabContent.forEach((content) => {
    if (content.dataset.index == tabTarget) {
      content.classList.toggle("hide");
      icon.classList.toggle("accordion-header-icon--minus");
    } else {
      content.classList.add("hide");

      const contentIndex = content.dataset.index;
      const currentAccordionLabel = document.querySelector(
        `[data-target="${contentIndex}"]`
      );
      const currentIcon = currentAccordionLabel.querySelector(
        ".accordion-header-icon"
      );
      currentIcon.classList.remove("accordion-header-icon--minus");
    }
  });
};

/** *This function  checks if `contentTabs` and `accordionTabs` exist and adds event
listeners to them accordingly. If `contentTabs` exist, it adds a click event listener to each tab
and calls the `toggleTabs` and `showActiveTabContent` functions when a tab is clicked. If a tab is
already selected, it calls the `showActiveTabContent` function to display the corresponding content.
If `accordionTabs` exist, it calls the `showHideAccordions` function to add click event listeners to
each accordion tab. */
$(document).ready(() => {
  if (contentTabs) {
    contentTabs.forEach((tab) => {
      tab.addEventListener("click", (e) => {
        toggleTabs(tab);
        showActiveTabContent(tab.dataset.product);
      });
      if (tab.dataset.selected == "true") {
        showActiveTabContent(tab.dataset.product);
      }
    });
  }
  if (accordionTabs) {
    showHideAccordions();
  }
});

document.addEventListener("shopify:section:load", () => {
  if (contentTabs) {
    contentTabs.forEach((tab) => {
      tab.addEventListener("click", (e) => {
        toggleTabs(tab);
        showActiveTabContent(tab.dataset.product);
      });
      if (tab.dataset.selected == "true") {
        showActiveTabContent(tab.dataset.product);
      }
    });
  }
  if (accordionTabs) {
    showHideAccordions();
  }
});
